
//设置用户信息
export function setUserInfo (userInfoData) {
  return localStorage.setItem('USER_INFO', `${JSON.stringify(userInfoData)}`);
}
//清空用户信息
export function ClearUserInfo () {
  return localStorage.removeItem('USER_INFO');
}
//获取用户信息
export function getUserInfo () {
  let NC_USER_INFO = localStorage.getItem('USER_INFO') || '{}';
  return JSON.parse(NC_USER_INFO);
}

//设置systemconfig信息
export function setSystemConfig (data) {
  return localStorage.setItem('SYSTEM_CONFIG', `${JSON.stringify(data)}`);
}
//清空systemconfig信息
export function ClearSystemConfig () {
  return localStorage.removeItem('SYSTEM_CONFIG');
}
//获取systemconfig信息
export function getSystemConfig () {
  let NC_USER_INFO = localStorage.getItem('SYSTEM_CONFIG') || '{}';
  return JSON.parse(NC_USER_INFO);
}
//获取systemconfig信息 通过key值
export function getSystemConfigByKey (key) {
  let NC_USER_INFO = localStorage.getItem('SYSTEM_CONFIG') || '{}';
  var arr = JSON.parse(NC_USER_INFO);
  var obj = arr.find(x=>x.key==key);
  return obj==null?"":obj.value;
}


//jwt Token
export function setToken (Token) {
  return localStorage.setItem('jwtToken', Token);
}
//清空 Token
export function ClearToken () {
  return localStorage.removeItem('jwtToken');
}
//获取 Token
export function getToken () {
  return  localStorage.getItem('jwtToken') || '';
}


